import React, { FunctionComponent } from 'react';

import { Link } from '..';
import { setIsFaqModalVisible } from '../../features/settings';
import { i18n } from '../../helpers/i18n';
import { useActions } from '../../hooks';
import css from './index.css';

interface FaqButtonProps {
    onClick?: () => void;
}

export const FaqLink: FunctionComponent<FaqButtonProps> = ({ onClick }) => {
    const actions = useActions({ setIsFaqModalVisible });

    const handleClick = () => {
        onClick?.();
        actions.setIsFaqModalVisible(true);
    };

    return (
        <Link view="default" onClick={handleClick} className={css.link}>
            {i18n('faq', 'title')}
        </Link>
    );
};
